import Backbone from 'backbone'

/**
 *
 * @type {LdapServers}
 */
var LdapServers = Backbone.Collection.extend()

export default LdapServers

LdapServers.__filename__ = 'admin/configuration/ldap-servers-model.js'
